<template>
  <v-dialog v-model="openAiInfo" width="450">
    <v-card class="pa-4">
      <v-card-title class="pa-0 ma-0 align-center d-flex justify-space-between">
        <div class="d-flex align-center">
          <span class="text-h5">Disclaimer</span>
        </div>
        <v-btn
          size="x-small"
          variant="text"
          icon
          color="grey"
          @click="openAiInfo = false"
        >
          <v-icon >mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <p class="mt-6">By using our AI Copilot, you agree to share data with your selected third-party model provider
        (Google for Gemini models, OpenAI for GPT models, Anthropic for Claude models). Each provider has its own data usage and privacy
        policies.</p>
      <p class="mt-6"> <strong>When using OpenAI models:</strong></p>
      <p class="mt-2"><a href="https://openai.com/policies/privacy-policy" target="_blank">OpenAI Privacy Policy</a></p>
      <p class="mt-2">
        <a href="https://openai.com/policies/api-data-usage-policies" target="_blank">OpenAI Data Usage Policies</a>
      </p>
      <p class="mt-2"><a href="https://openai.com/security" target="_blank">OpenAI Security</a></p>
      <p class="mt-6"> <strong>When using Google's Gemini models:</strong></p>
      <p class="mt-2"><a href="https://policies.google.com/privacy" target="_blank">Google Privacy Policy</a></p>
      <p class="mt-2">
        <a href="https://cloud.google.com/gemini/docs/discover/data-governance" target="_blank">
          Google Cloud AI Data Usage Policies
        </a>
      </p>
      <p class="mt-2">
        <a href="https://cloud.google.com/vertex-ai/docs/generative-ai/data-governance" target="_blank">
          Gemini API Security & Data Governance
        </a>
      </p>
      <p class="mt-6"> <strong>When using Anthropic's Claude models:</strong></p>
      <p class="mt-2"><a href="https://privacy.anthropic.com/en/" target="_blank">Anthropic Privacy Center</a></p>
      <p class="mt-2"><a href="https://www.anthropic.com/legal/privacy" target="_blank">Anthropic Privacy Policy</a></p>
      <p class="mt-2">
        <a href="https://www.anthropic.com/news/usage-policy-update" target="_blank">Anthropic Usage Policy</a>
      </p>
      <v-checkbox
        class="mt-6"
        v-model="aiDisclaimerPreference"
        :label="$route.params.projectId ? 'Don\'t show again for this project' : 'Don\'t show again when creating projects'"
      />
      <v-card-actions class="pa-0 mt-2 justify-end" style="padding: 0 !important;">
        <v-btn variant="outlined" size="large" @click="openAiInfo = false">Cancel</v-btn>
        <v-btn variant="flat" size="large" @click="saveDisclaimerPreference">{{
          "OK"
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      openAiInfo: false,
      aiDisclaimerPreference: localStorage.getItem(`showAiInfo-${this.$route.params.projectId ? this.$route.params.projectId : 'dashboard'}`) === 'true'
    }
  },
  props: ['open'],
  methods: {
    saveDisclaimerPreference () {
      this.setShowAiInfo(`${this.aiDisclaimerPreference}`)
      this.openAiInfo = false
      this.$emit('conditions-accepted')
    },
    openDialog () {
      if (this.getShowAiInfo()) {
        this.openAiInfo = false
        this.$emit('conditions-accepted')
      } else {
        this.openAiInfo = true
      }
    },
    close () {
      this.openAiInfo = false
      this.$emit('close')
    },
    getShowAiInfo () {
      if (this.$route.params.projectId) {
        return localStorage.getItem(`showAiInfo-${this.$route.params.projectId}`) === 'true'
      } else {
        return localStorage.getItem('showAiInfo-dashboard') === 'true'
      }
    },
    setShowAiInfo (value) {
      if (this.$route.params.projectId) {
        localStorage.setItem(`showAiInfo-${this.$route.params.projectId}`, value)
      } else {
        localStorage.setItem('showAiInfo-dashboard', value)
      }
    }
  }
}
</script>

<style scoped>
[data-theme="dark"] a {
  color: var(--blue-1);
}
</style>
